import { Trash2 } from "lucide-react";

export default function ResetDialog({
  resetFrom, setResetFrom, resetTo, setResetTo,
  onClose, onConfirm, saving,
}) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={onClose} data-testid="reset-dialog-overlay">
      <div className="rounded-lg shadow-xl max-w-md w-full mx-4 p-6" style={{ background: "var(--tga-bg-card)", border: "1px solid var(--tga-border-strong)" }} onClick={(e) => e.stopPropagation()} data-testid="reset-dialog">
        <h3 className="text-lg font-semibold mb-4" style={{ color: "var(--tga-text-bright)" }} data-testid="reset-dialog-title">Stundenkonto vollstaendig zuruecksetzen?</h3>

        <div className="flex gap-3 mb-4">
          <div className="flex-1">
            <label className="block text-xs font-medium mb-1" style={{ color: "var(--tga-text-muted)" }}>Von</label>
            <input type="date" value={resetFrom} onChange={(e) => setResetFrom(e.target.value)} className="w-full px-3 py-2 text-sm rounded focus:outline-none" data-testid="reset-from-date" />
          </div>
          <div className="flex-1">
            <label className="block text-xs font-medium mb-1" style={{ color: "var(--tga-text-muted)" }}>Bis</label>
            <input type="date" value={resetTo} onChange={(e) => setResetTo(e.target.value)} className="w-full px-3 py-2 text-sm rounded focus:outline-none" data-testid="reset-to-date" />
          </div>
        </div>

        <p className="text-sm mb-2" style={{ color: "var(--tga-text-secondary)" }}>Die folgenden Daten im gewaehlten Zeitraum werden geloescht:</p>
        <ul className="text-sm mb-4 space-y-1 list-disc list-inside" style={{ color: "var(--tga-text-primary)" }}>
          <li>Arbeitszeiten</li>
          <li>Fahrten</li>
          <li>Kilometer</li>
          <li>Urlaubseintraege</li>
          <li>Kranktage</li>
          <li>Saldo</li>
        </ul>
        <p className="text-sm font-semibold text-red-600 mb-5" data-testid="reset-warning">Diese Aktion kann nicht rueckgaengig gemacht werden.</p>

        <div className="flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 text-sm font-medium rounded transition-colors" style={{ color: "var(--tga-text-primary)", background: "var(--tga-bg-content)" }} data-testid="reset-cancel-btn">Abbrechen</button>
          <button onClick={onConfirm} disabled={saving || !resetFrom || !resetTo || resetFrom > resetTo} className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 disabled:opacity-50 rounded transition-colors" data-testid="reset-confirm-btn">Stundenkonto im Zeitraum zuruecksetzen</button>
        </div>
      </div>
    </div>
  );
}
